import { GzInfoBoxWebComponent } from './component/GzInfoBoxWebComponent';

export { GzInfoBoxWebComponent };
